import { render } from "./ExternalIframe.vue?vue&type=template&id=383bca7e&scoped=true&ts=true"
import script from "./ExternalIframe.vue?vue&type=script&lang=ts"
export * from "./ExternalIframe.vue?vue&type=script&lang=ts"

import "./ExternalIframe.vue?vue&type=style&index=0&id=383bca7e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383bca7e"]])

export default __exports__